import React from 'react';
import Slider from 'react-slick';
// import Particles from "react-tsparticles"; // Remove this line
// import { loadSlim } from "tsparticles-slim"; // Remove this line
import './HeroSection.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const HeroSection = () => {
  // Remove the particlesInit function
  // const particlesInit = async (engine) => {
  //   await loadSlim(engine);
  // };

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    fade: true,
    cssEase: 'linear',
    arrows: false
  };

  const slides = [
    {
      heading: "Fortify Your Systems with SAP Security!",
      link: "/contact-us",
      buttonText: "Explore SAP Security Solutions"
    },
    {
      heading: "Empower Innovation with SAP BTP!",
      link: "/contact-us",
      buttonText: "Learn About SAP BTP"
    },
    {
      heading: "Secure, Simplify & Streamline with SAP GRC Solutions!",
      link: "/contact-us",
      buttonText: "Discover Our GRC Services"
    },
    {
      heading: "Expert Guidance for SAP Success!",
      link: "/contact-us",
      buttonText: "Achieve SAP Success"
    }
  ];

  return (
    <div className="hero-container">
      {/* Remove the Particles component entirely */}
      {/*
      <Particles
        id="tsparticles"
        init={particlesInit}
        options={{
          background: { color: { value: "#000000" } },
          fpsLimit: 60,
          interactivity: {
            events: { onHover: { enable: true, mode: "repulse" }, resize: true },
            modes: { repulse: { distance: 100, duration: 0.4 } }
          },
          particles: {
            color: { value: "#ffffff" },
            links: { color: "#ffffff", distance: 150, enable: true, opacity: 0.2, width: 1 },
            collisions: { enable: true },
            move: { direction: "none", enable: true, outModes: { default: "bounce" }, random: false, speed: 1, straight: false },
            number: { density: { enable: true, area: 800 }, value: 80 },
            opacity: { value: 0.2 },
            shape: { type: "circle" },
            size: { value: { min: 1, max: 3 } }
          },
          detectRetina: true
        }}
      />
      */}
      <div className="hero-content">
        
        <Slider {...sliderSettings}>
          {slides.map((slide, index) => (
            <div key={index} className="slide">
              <h1 className="slide-heading">{slide.heading}</h1>
              <a href={slide.link} className="slide-button">{slide.buttonText}</a>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default HeroSection;